import { GetShippingAddresses } from './getShippingAddresss.js'
import {DEFAULT_PAGE} from "../../contstants";
import getDateRange from "../../utils/getDateRange";
const FilterShippingAddresses = async (perPage,filters) => {
    const page = filters.page || DEFAULT_PAGE;
    const name = filters.s || '';
    const ids = filters.ids || '';
    const company_id = filters.company_id || '';
    const office_ids = filters.office_ids || '';
    let isActive = true;
    if(filters.status === 'active'){
        isActive = true;
    }
    if(filters.status === 'inactive'){
        isActive = false;
    }
    const { dateFrom, dateTo } = getDateRange(filters.date);

    return await GetShippingAddresses({
       limit: perPage, offset: (page - 1) * perPage,  name, ids , company_id, office_ids, isActive, created_on_gte: dateFrom, created_on_lte: dateTo
    });
};

export default FilterShippingAddresses;
